<div class="payee-accordion-wrapper" [class.open]="open">
  <div class="payee-accordion-header" (click)="onClick()">
    <h2 [attr.color]="open ? 'black' : 'grey-dark'">{{headline}}</h2>
    <payee-icon name="plus-black-circle-white" *ngIf="!open" width="40" height="40"></payee-icon>
    <payee-icon name="cross-white-circle-black" *ngIf="open" width="40" height="40"></payee-icon>
  </div>
  <div #content class="payee-accordion-content" [style.--scroll-height]="content.scrollHeight + 'px'">
    <ng-content></ng-content>
  </div>
</div>